module.exports = __webpack_public_path__ + "static/media/package_develop_turn_key.0590c443.svg";